import { render, staticRenderFns } from "./industryTab1.vue?vue&type=template&id=5b8f8b98&scoped=true"
import script from "./industryTab1.vue?vue&type=script&lang=js"
export * from "./industryTab1.vue?vue&type=script&lang=js"
import style0 from "./industryTab1.vue?vue&type=style&index=0&id=5b8f8b98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f8b98",
  null
  
)

export default component.exports